import {
  AppBar,
  Toolbar,
  Button,
  Box,
  Menu,
  Grid,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { Link as RouterLink } from "react-router-dom";

/* ===== Icons ===== */
import ApiIcon from "@mui/icons-material/Api";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import LanguageIcon from "@mui/icons-material/Language";
import SmartToyIcon from "@mui/icons-material/SmartToy";
import PrecisionManufacturingIcon from "@mui/icons-material/PrecisionManufacturing";

/* ===== Services Config ===== */
const services = [
  {
    title: "APIs and Microservices",
    icon: <ApiIcon fontSize="small" />,
    link: "/services/api-microservices",
  },
  {
    title: "Mobile App Development",
    icon: <PhoneIphoneIcon fontSize="small" />,
    link: "/services/mobile-development",
  },
  {
    title: "Web Application Development",
    icon: <LanguageIcon fontSize="small" />,
    link: "/services/web-development",
  },
  {
    title: "Robotic Process Automation",
    icon: <PrecisionManufacturingIcon fontSize="small" />,
    link: "/services/rpa",
  },
  {
    title: "Artificial Intelligence",
    icon: <SmartToyIcon fontSize="small" />,
    link: "/services/artificial-intelligence",
  },
];

export default function Navbar() {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleOpen = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  return (
      <AppBar
        position="absolute"
        elevation={0}
        sx={{
          px: 6,
          backgroundColor: "rgba(245, 245, 245, 0.8)", // light grey glass
          backdropFilter: "blur(10px)", // glass effect
          borderBottom: "1px solid rgba(0,0,0,0.05)",
        }}
      >
      <Toolbar disableGutters sx={{ width: "100%" }}>
        {/* Logo */}
        <Box
          component={RouterLink}
          to="/"
          sx={{
            mr: 4,
            display: "flex",
            alignItems: "center",
            cursor: "pointer",

            px: 1.5,
            py: 0.6,
            borderRadius: "12px",


          }}
        >
          <Box
            component="img"
            src="/nerdshub-logo-unit.png"
            alt="Nerdshub"
            sx={{
              height: 65,
              objectFit: "contain",
            }}
          />
        </Box>

        {/* Main Menu */}
        <Box sx={{ display: "flex", alignItems: "center" }}>
         <Button
            sx={navStyle}
            component={RouterLink}
            to="/"
          >
            Who We Are
          </Button>

          <Button
            sx={navStyle}
            component={RouterLink}
            to="/what-we-do"
            onMouseEnter={handleOpen}
          >
            What We Do
          </Button>

          <Button
            component={RouterLink}
            to="/industries"
            sx={navStyle}
          >
            Industries We Serve
          </Button>
          <Button
            component={RouterLink}
            to="/careers"
            sx={navStyle}
          >
            Careers
          </Button>

          <Button component={RouterLink} to="/verify" sx={navStyle}>
            Contact Us
          </Button>
        </Box>

        {/* Mega Menu */}
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleClose}
          MenuListProps={{ onMouseLeave: handleClose }}
          sx={{
            mt: 1,
            "& .MuiPaper-root": {
              background: "linear-gradient(180deg, #020617, #000)",
              color: "#fff",
              p: 4,
              width: 820,
            },
          }}
        >
          <Grid container spacing={4}>
            <Grid item xs={6}>
              {services.slice(0, 3).map((item) => (
                <ServiceItem key={item.title} {...item} />
              ))}
            </Grid>

            <Grid item xs={6}>
              {services.slice(3).map((item) => (
                <ServiceItem key={item.title} {...item} />
              ))}
            </Grid>
          </Grid>
        </Menu>
      </Toolbar>
    </AppBar>
  );
}

/* ===== Styles ===== */

const navStyle = {
  color: "#000000",
  mx: 1,
  textTransform: "none",
  fontSize: "15px",
};

/* ===== Service Item ===== */

function ServiceItem({ title, icon, link }) {
  return (
    <Box
      component={RouterLink}
      to={link}
      sx={{
        display: "flex",
        alignItems: "center",
        mb: 2.5,
        textDecoration: "none",
        color: "#e5e7eb",
        transition: "0.2s",
        "&:hover": {
          color: "#ff0080",
        },
      }}
    >
      <Box
        sx={{
          width: 34,
          height: 34,
          borderRadius: "50%",
          backgroundColor: "#ff0080",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          mr: 2,
          color: "#fff",
        }}
      >
        {icon}
      </Box>

      <Typography fontSize="15px">{title}</Typography>
    </Box>
  );
}
